module.exports = __webpack_public_path__ + "media/images/haircut/weinie-b3eab87337080b18e9c1aecc5ac1ffd3.jpg";